import { localisedValue } from "utils"
import { flagColorMap } from "features/shared/data"

export const leadLabelsTransformer = labels => {
  const flagColorIdMap = {}
  const transform = item => {
    flagColorIdMap[item?.id] = flagColorMap[item?.key]
    return [
      {
        ...item,
        key: item?.key,
        value: item?.id?.toString(),
        label: localisedValue({ object: item, key: "title" }),
      },
      ...(item?.children?.flatMap(transform) || []),
    ]
  }
  const data = labels?.flatMap(transform)
  return { data, flagColorIdMap }
}
